import { Page } from "model/Page";
import { Servidor } from "model/ufc/Servidor";
import { QueryParamsFormatter } from "service/QueryParamsFormatter";
import { OrdemColunaTabela } from "view/component/Tabela/model/OrdemColunaTabela";
import { Api } from "../Api";
import { ApiAxios } from "../ApiAxios";


export interface ServidoresQueryParams {
  nome?: string;
  situacao?: boolean;
  idUnidadeExercicio?: number;
  idSuperUnidadeExercicio?: number;
}


export class ApiServidores {
  /**
   * @param pagina Primeira página é a `1`
   */
  static async getServidores(idReino: number, pagina?: number, query?: ServidoresQueryParams, ordem?: OrdemColunaTabela): Promise<Page<Servidor>> {
    const paginaSpringBoot = Api.pageConvertion(pagina ?? 1);

    const queryParams = QueryParamsFormatter.format(query ?? {});
    const pageParams = `page=${paginaSpringBoot}&size=10`;
    
    const url = `/reinos/${idReino}/ufc/servidores?${pageParams}&${queryParams}&${Api.ordemToApi(ordem)}`;

    const response = await ApiAxios.instance.get(url);
    return response.data;
  }
}
